'use client';

import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { useChatbotOpen } from '@/components/chatbot/use-chatbot-open';
import { useScroll } from '@/utils/use-scroll';
import MainBar from './main-bar';
import './style.css';
import SubMenu from './mega-menu/sub-menu';
interface Props {
  className?: string;
  hideMainHeaderOnMobile?: boolean;
}
function HeaderContent({
  className,
  hideMainHeaderOnMobile = false
}: Props) {
  const [isGoftinoOpen, setGoftinoOpen] = useState(false);
  const {
    isChatOpen
  } = useChatbotOpen();
  const {
    isMobile
  } = useMobileDetect();
  const {
    isScrollingUp,
    scrollY
  } = useScroll();
  useEffect(() => {
    const onOpen = () => setGoftinoOpen(true);
    const onClose = () => setGoftinoOpen(false);
    window.addEventListener('goftino_openWidget', onOpen);
    window.addEventListener('goftino_closeWidget', onClose);
    return () => {
      window.removeEventListener('goftino_openWidget', onOpen);
      window.removeEventListener('goftino_closeWidget', onClose);
    };
  }, []);
  if (hideMainHeaderOnMobile && isMobile) return null;
  let topOfGoftinoClass;
  if (isGoftinoOpen) {
    topOfGoftinoClass = 'z-header';
  } else if (isChatOpen) {
    topOfGoftinoClass = 'z-artin-header';
  } else {
    topOfGoftinoClass = 'z-top-of-chatbot-plus1';
  }
  return <header id='header' className={classNames('sticky top-0 w-full bg-white shadow-sm transition-all duration-500 lg:p-0', topOfGoftinoClass, className, {
    'lg:relative': !isScrollingUp
  }, {
    slideInDown: isScrollingUp && scrollY > 700
  }, isMobile ? 'px-0' : 'px-2 py-3')} data-sentry-component="HeaderContent" data-sentry-source-file="header-content.tsx">
            <MainBar data-sentry-element="MainBar" data-sentry-source-file="header-content.tsx" />
            {!isMobile && <SubMenu />}
        </header>;
}
export default HeaderContent;